module.exports = new __parcel__URL__("card-colors-app-skeleton.tpl.8b0bbc0d.svg").toString();